// src/components/app-components/find-investors-modules/investorDeals.js
import { useTranslation } from 'react-i18next';

const InvestorDealsCount = ({ totalDeals, leadCount, participatedCount, bothCount = 0 }) => {
  const { t } = useTranslation();

  return (
    <div className="rounded-md p-2">
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-x-4 gap-y-2 items-start">
        <div>
          <h3 className="text-stone-900 text-base font-semibold m-0">
            {t('pageInvProf.dealsCount')}: {totalDeals}
          </h3>
        </div>

        <div>
          <p className="text-base m-0">
            <strong>{t('pageInvProf.leadInvTitle')}:</strong> {leadCount}
          </p>
          <p className="text-sm m-0">
            {t('pageInvProf.labelBoth2')} {bothCount}
          </p>
        </div>

        <div>
          <p className="text-base m-0">
            <strong>{t('pageInvProf.secondInvTitle')}:</strong> {participatedCount}
          </p>
        </div>
      </div>
    </div>
  );
};

export default InvestorDealsCount;
